import React, { useMemo } from 'react';
import { ReactNode, cloneElement } from 'react';
import tinycolor from 'tinycolor2';

interface TitleTagProps {
  className?: string;
  backgroundColor?: string;
  children: ReactNode;
}

export const TitleTag = ({ children, className, backgroundColor }: TitleTagProps) => {
  // 默认背景色
  const bg = useMemo(() => {
    if (!backgroundColor) return '#000';
    return backgroundColor;
  }, [backgroundColor]);

  const color = useMemo(() => {
    const tinycolorBG = tinycolor(bg);
    if (tinycolorBG.toHexString() === '#000000') return '#fff';
    return tinycolorBG.isLight() ? tinycolorBG.darken(40).toHexString() : '#fff';
  }, [bg]);

  // 透明毛玻璃
  const style = {
    backdropFilter: 'blur(6px)',
    background: tinycolor(bg).setAlpha(0.3).toRgbString(),
    color,
  };

  // 让所有子元素（如图标）都继承 color
  const childrenWithColor = Array.isArray(children)
    ? children.map((child) => (typeof child === 'string' ? child : cloneElement(child as any, { color })))
    : typeof children === 'string'
    ? children
    : cloneElement(children as any, { color });

  return (
    <span className={`px-3 h-[28px] leading-[28px] text-sm rounded-xl ${className}`} style={style}>
      {childrenWithColor}
    </span>
  );
};
